module.exports = __webpack_public_path__ + "img/@logo_kbfg.fb3fdcaf.svg";